import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Event} from '../../../../model/event/event.model';
import {FormsModule} from '@angular/forms';
import {DatePipe, NgFor} from '@angular/common';

@Component({
    standalone: true,
    selector: 'app-dialog-select-young-event',
    templateUrl: './dialog-select-young-event.component.html',
    styleUrls: ['./dialog-select-young-event.component.scss'],
    imports: [NgFor, FormsModule, DatePipe]
})
export class DialogSelectYoungEventComponent implements OnInit, OnDestroy {
  dialogRef = inject<MatDialogRef<DialogSelectYoungEventComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  result;
  abort = true;

  events: Event[] = [];

  constructor() {
    const dialogRef = this.dialogRef;

    dialogRef.disableClose = true;
  }

  ngOnInit() {
    if (!this.events || this.events.length === 0) {
      this.dialogRef.close();
    }
  }

  exit() {
    this.abort = false;
    this.dialogRef.close();
  }

  abortAction() {
    this.abort = true;
    this.dialogRef.close();
  }

  ngOnDestroy() {
    // Exit without choose young or create new
    if (this.abort) {
      this.dialogRef.close();
    } else {
      this.dialogRef.close(this.result ? this.result : {});
    }
  }

  formatEventName(event: Event) {
    return 'Événement : ' + event.eventType + ' - Capacité : ' + event.numberPlaces;
  }
}
